const CHAT_CACHE_MIGRATION_KEY = 'nexora_chat_cache_migration_v1';

const safely = callback => {
  try { callback(); } catch (e) {}
};

export function runChatCacheMigration() {
  try {
    if (localStorage.getItem(CHAT_CACHE_MIGRATION_KEY) === 'done') return;

    const chatKeys = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (
        key &&
        (key.startsWith('nexora_p2p_msgs_') ||
          key.startsWith('nexora_p2p_scroll_') ||
          key.startsWith('nexora_msg_pins_') ||
          key.startsWith('nexora_p2p_block_'))
      ) {
        chatKeys.push(key);
      }
    }

    chatKeys.forEach(key => localStorage.removeItem(key));
    localStorage.setItem(CHAT_CACHE_MIGRATION_KEY, 'done');
  } catch (e) {
    // Do not set the flag if the cleanup could not complete; a later startup
    // can safely retry it. Non-chat data is never part of this migration.
  }
}

export function clearConversationCache(roomId) {
  if (!roomId) return;
  safely(() => {
    localStorage.removeItem(`nexora_p2p_msgs_${roomId}`);
    localStorage.removeItem(`nexora_p2p_scroll_${roomId}`);
    localStorage.removeItem(`nexora_msg_pins_${roomId}`);
    localStorage.removeItem(`nexora_p2p_block_${roomId}`);
  });
}

export function getConversationBlockCache(roomId) {
  try {
    const cached = JSON.parse(localStorage.getItem(`nexora_p2p_block_${roomId}`) || 'null');
    return cached && typeof cached === 'object' ? cached : null;
  } catch (e) {
    return null;
  }
}

export function saveConversationBlockCache(roomId, values) {
  if (!roomId) return;
  safely(() => {
    const current = getConversationBlockCache(roomId) || {};
    localStorage.setItem(
      `nexora_p2p_block_${roomId}`,
      JSON.stringify({ ...current, ...values, updatedAt: Date.now() })
    );
  });
}
